import VueJsModal from "vue-js-modal";

import Vue from "vue";
Vue.use(VueJsModal);
